module.exports = __webpack_public_path__ + "assets/81991e0329fd1010927db7aeff0e66aa.svg";